<script lang="ts">
import { useCtaComponent } from '@monogrid/vue-boost/core'
import { templateRef } from '@vueuse/core'
import { defineComponent } from 'vue'

import { useTracking } from '@/functions/useTracking'

export default defineComponent({
  name: 'ActionChip',
  props: {
    active: { type: Boolean, default: false }
  },
  setup (props, context) {
    const chip = templateRef<HTMLElement>('chip')
    const { bindings, component } = useCtaComponent(context)

    useTracking(chip, { event: 'holidayExperienceCta' })

    return {
      bindings,
      component
    }
  }
})
</script>

<template>
  <component
    :is="component"
    ref="chip"
    v-bind="bindings"
    class="chip inline-flex h-6 px-2 items-center justify-center"
    :class="{ active }"
  >
    <slot />
  </component>
</template>

<style lang="scss" scoped>
.chip {
  padding-top: 0.1em;
  border-width: 1px;
  border-style: solid;
  border-color: var(--chip-bg-color);
  border-radius: rem(12px);
  background-color: var(--chip-bg-color);
  color: var(--chip-txt-color);
  transition: border-color $default-duration, background-color $default-duration, color $default-duration;

  &.active {
   border-color: $c-black;
   background-color: $c-black;
   color: $c-white;
   pointer-events: none;
  }

  &:not(.active) {
    border-color: $c-black;
    background-color: transparent;
    color: $c-black;
    pointer-events: none;
    pointer-events: auto;

    @include hover {
      &:hover {
        border-color: $c-black;
        background-color: $c-black;
        color: $c-white;
      }
    }
  }

}

</style>
